import { styled } from '@mui/system';

export const Wrapper = styled('main')`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`;
